<template>
  <div>
    <v-data-table
      :headers="headers"
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
      no-data-text=""
    >
      <template v-slot:body.prepend>
        <tr>
          <td>
            <type-filter
              v-model="filters.type"
              item-text="name"
              item-value="id"
            />
          </td>
          <td>
            <first-name-filter v-model="filters.first_name" />
          </td>
          <td>
            <last-name-filter v-model="filters.last_name" />
          </td>
          <td>
            <phone-filter v-model="filters.phone" />
          </td>
          <td>
            <serial-numbers-filter v-model="filters.serial_number" />
          </td>
          <td>
            <device-codes-filter
              v-model="filters.device_code"
              item-text="name"
              item-value="name"
            />
          </td>
          <td>
            <status-filter
              v-model="filters.status"
              item-value="id"
              item-text="name"
              clearable
            />
          </td>
          <td colspan="2">
            <div class="d-flex">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="grey"
                    depressed
                    outlined
                    @click="reset"
                    v-on="on"
                  >
                    <v-icon>mdi-filter-remove</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('BUTTON.CLEAR_FILTER') }}</span>
              </v-tooltip>
              <v-spacer class="mx-1"></v-spacer>
              <v-btn color="primary" depressed @click.prevent="refreshData">
                {{ $t('BUTTON.FIND') }}
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import TypeFilter from './filters/TypeFilter.vue';
import FirstNameFilter from './filters/FirstNameFilter.vue';
import LastNameFilter from './filters/LastNameFilter.vue';
import PhoneFilter from './filters/PhoneFilter.vue';
import SerialNumbersFilter from './filters/SerialNumbersFilter.vue';
import DeviceCodesFilter from './filters/DeviceCodesFilter.vue';
import StatusFilter from './../../components/filters/StatusFilter.vue';

export default {
  name: 'DevicesListFilter',

  components: {
    TypeFilter,
    FirstNameFilter,
    LastNameFilter,
    PhoneFilter,
    SerialNumbersFilter,
    DeviceCodesFilter,
    StatusFilter
  },

  data() {
    return {
      filters: {}
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.TYPE'),
          value: 'type.name'
        },
        {
          text: this.$t('PROFILE.FIRST_NAME'),
          value: 'first_name'
        },
        {
          text: this.$t('PROFILE.LAST_NAME'),
          value: 'last_name'
        },
        {
          text: this.$t('DEVICES.PHONE'),
          value: 'phone'
        },
        {
          text: this.$t('DEVICES.SERIAL_NUMBER'),
          value: 'serial_number'
        },
        {
          text: this.$t('DEVICES.DEVICE_CODE'),
          value: 'name'
        },
        {
          text: this.$t('ITEM.STATUS'),
          value: 'status'
        },
        {
          text: '',
          sortable: false
        }
      ];
    }
  },

  methods: {
    refreshData() {
      this.$emit('setRequest', { ...this.filters });
    },

    reset() {
      this.filters = {};
      this.refreshData();
    }
  }
};
</script>
